module.exports = __webpack_public_path__ + "static/media/Remelting.eff02f23.png";